const CookieSettings = {
    cookieTier: "_tbc_analytics_consent",
    consent: "_tbc_consent_seen",
    customEventName: "consentchange",
    defaultTier: 2
} as const;

export default CookieSettings;